module.exports = __webpack_public_path__ + "static/media/blocked.429c63ca.png";